<template>
  <div class="menu" v-if="userName">
    <el-dropdown trigger="click">
      <span class="el-dropdown-link">
        <i class="el-icon-user fc"></i>
        <span class="fc">{{ userName }}</span>
        <i class="el-icon-arrow-down el-icon--right fc"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <span @click="goUser">
          <el-dropdown-item><span>个人权益</span></el-dropdown-item>
        </span>
        <span @click="goUserCenter">
          <el-dropdown-item><span>个人中心</span></el-dropdown-item>
        </span>
        <span @click="exit()">
          <el-dropdown-item><span>退出</span></el-dropdown-item>
        </span>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userName: null, // 用户名称
    };
  },
  methods: {
    goUser() {
      this.$router.push("/user");
    },
    // 前往个人中心
    goUserCenter() {
      window.open("https://i.ringdata.com/index");
    },
    /*退出账户*/
    exit: function () {
      this.$cookies.remove("tokenWeb");
      this.$cookies.remove("userInfo");
      //先清除，防止账号切换时，isRequestor未更新
      this.$cookies.remove("isRequestor");
      this.$cookies.remove("tokenWeb", "/", "ringdata.com");
      this.$cookies.remove("userInfo", "/", "ringdata.com");
      this.$emit("login-out");
      setTimeout(() => {
        this.$router.push("/login");
      }, 1.5 * 1000);
    },
  },
  created() {
    let userInfo = this.$cookies.get("userInfo");
    if (userInfo && userInfo.name) {
      this.userName = userInfo.name;
    }
  },
};
</script>

<style lang="scss" scoped>
.menu {
  .el-dropdown {
    display: inline-block;
    position: relative;
    color: #f1f1f1 !important;
    font-size: 14px;
  }
  line-height: 60px;
  float: right;
  text-align: center;
  cursor: pointer;
  margin-left: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/buttonUser.vue